import styled from "styled-components"

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100svh;
`

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 0 0 64px 0;
`

export const HeaderArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const PageTitle = styled.h1<{ $align?: string }>`
  font-size: 28px;
  font-weight: 700;
  color: #1a1f2e;
  text-align: ${({ $align }) => $align ?? "left"};
  line-height: 1.2;

  @media (max-width: ${({ theme }) => theme.bp.small}px) {
    font-size: 24px;
  }
`

export const PageSubtitle = styled.p`
  font-size: 15px;
  color: #6b7280;
  margin: 0;
  line-height: 1.4;
`

export const List = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 400px));
  gap: 24px;
  justify-content: center;
  max-width: 100%;

  @media (max-width: ${({ theme }) => theme.bp.small}px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`

export const LoadingWrapper = styled.div`
  width: 256px;
  margin: 40px auto;
`

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 16px;
  padding: 48px 24px;
  max-width: 400px;
  margin: 24px auto;
`

export const EmptyIllustration = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background-color: #eff6ff;
  color: ${({ theme }) => theme.colors.blue.main};

  svg {
    width: 36px;
    height: 36px;
  }
`

export const EmptyTitle = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: #1a1f2e;
  margin: 0;
`

export const EmptyText = styled.p`
  font-size: 15px;
  color: #6b7280;
  line-height: 1.5;
  margin: 0;
`
